var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('osdi-text-field',_vm._g(_vm._b({attrs:{"prepend-inner-icon":"mdi-at","type":"email"}},'osdi-text-field',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }